export const SETUP_OPTIONS = {
  NOT_STARTED: 'NOT_STARTED',
  SELECT_BOAT: 'SELECT_BOAT',
  SKIPPED: 'SKIPPED',
  FINISHED: 'FINISHED',
};
